// extracted by mini-css-extract-plugin
module.exports = {"AddNextBtn":"AddNextBtn_AddNextBtn__1EqMe"};